import axios from "axios";

class SkillService {
  static BASE_URL = process.env.REACT_APP_BASE_URL2;


  //Skill Management Page
  static async getAllTracks() {
    try {
      const response = await axios.get(`${SkillService.BASE_URL}/admin/api/skill-master/get-all-tracks`);
      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getAllSkillsByTrack(track) {
    try {
      const response = await axios.get(`${SkillService.BASE_URL}/admin/api/skill-master/get-all-skills-by-track/${track}`);
      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async addSkill(skillData) {
    try {
      const response = await axios.post(`${SkillService.BASE_URL}/admin/api/skill-master/add-skill`, skillData);
      return response.data;
    } catch (err) {
      console.error("Error fetching user by ID:", err);
      throw err;
    }
  }

  static async updateSkill(payload) {
    try {
      const response = await axios.put(`${SkillService.BASE_URL}/admin/api/skill-master/update-skill`, payload);
      return response.data; // Directly return the response data
    } catch (error) {
      console.error("API Error:", error.response || error.message);
      throw new Error(
        error.response?.data?.message || "Failed to communicate with the server."
      );
    }
  }

  static async deleteSkill(skillId) {
    try {
      const response = await axios.delete(`${SkillService.BASE_URL}/admin/api/skill-master/delete-skill/` + skillId);
      return response.data; // Directly return the response data
    } catch (error) {
      console.error("API Error:", error.response || error.message);
      throw new Error(
        error.response?.data?.message || "Failed to communicate with the server."
      );
    }
  }

  static async getSkillsByUserId(userId) {
    try {
      const response = await axios.get(`${SkillService.BASE_URL}/sme/api/skill-mapping/get-skill-mapping-details/${userId}`);
      return response.data;
    } catch (err) {
      console.error("Error fetching skill mapping details:", err);
      throw err;
    }
  }

  static async mapSkillToSME(payload) {
    try {
      const response = await axios.post(`${SkillService.BASE_URL}/sme/api/skill-mapping/map-skill-sme`, payload);
      return response.data; // Directly return the response data
    } catch (error) {
      console.error("API Error:", error.response || error.message);
      throw new Error(
        error.response?.data?.message || "Failed to communicate with the server."
      );
    }
  }

  static async updateSMESkillRating(payload) {
    try {
      const response = await axios.put(`${SkillService.BASE_URL}/sme/api/skill-mapping/update-sme-skill-raing`, payload);
      return response.data; // Directly return the response data
    } catch (error) {
      console.error("API Error:", error.response || error.message);
      throw new Error(
        error.response?.data?.message || "Failed to communicate with the server."
      );
    }
  }


  static async deleteSMESkillMapping(smeSkillMappingId) {
    try {
      const response = await axios.delete(`${SkillService.BASE_URL}/sme/api/skill-mapping/delete-skill-mapping/` + smeSkillMappingId);
      return response.data; // Directly return the response data
    } catch (error) {
      console.error("API Error:", error.response || error.message);
      throw new Error(
        error.response?.data?.message || "Failed to communicate with the server."
      );
    }
  }
  static async skillMatrixImport(formData) {
    try {
      const response = await axios.post(
        `${SkillService.BASE_URL}/admin/api/skill-mapping/import`, formData);
      return response.data;
    } catch (err) {
      console.error("Error importing skill matrix:", err);
      throw err;
    }
  }
  static async skillMatrixExport(track) {
    
    try {
      const response = await axios.get(
        `${SkillService.BASE_URL}/admin/api/skill-mapping/export/${track}`,
        { responseType: "blob" }
      );
      
      return response;
    } catch (err) {
      console.log("skillMatrixExport Error+++++++++++++++++++++++", err);
      throw err;
    }
  }
  static async skillMasterImport(formData, track) {
    try {
      const response = await axios.post(
        `${SkillService.BASE_URL}/admin/api/skill-master/import/${track}`, formData);
      return response.data;
    } catch (err) {
      console.error("Error importing skill master:", err);
      throw err;
    }
  }
  static async skillMasterExport(track) {
    try {
      const response = await axios.get(
        `${SkillService.BASE_URL}/admin/api/skill-master/export/${track}`,
        { responseType: "blob" }
      );
      return response;
    } catch (err) {
      console.log("skillMasterExport Error ", err);
      throw err;
    }
  }

  static async downloadSkillMatrixTemplate() {
    try {
      const response = await axios.get(
        `${SkillService.BASE_URL}/admin/api/skill-mapping/download-template`,
        { responseType: "blob" }
      );
      return response;
    } catch (err) {
      console.log("downloadSkillMatrixTemplate Error ", err);
      throw err;
    }
  }

    static async downloadSkillMasterTemplate() {
    try {      const response = await axios.get(
        `${SkillService.BASE_URL}/admin/api/skill-master/download-template`,
        { responseType: "blob" }
      );
      return response;
    } catch (err) {
      console.log("downloadSkillMasterTemplate Error ", err);
      throw err;
    }
  }
}


export default SkillService;